

exports.__esModule = true;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _auth = require('xo-models/src/auth');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

var _app = require('xo-models/src/app');

var _checkout = require('xo-models/src/checkout');

var _index = require('xo-return-to-merchant/dist/index');

require('./msbOffer/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTokenizationInfoPageDirective', {
    tag: 'xo-tokenization-info',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },

    resolve: {
        models: function models() {
            var checkoutCart = _checkout.$CheckoutCartModel.instance(this.props.token);
            var auth = _auth.$AuthModel.instance();
            return {
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPinModel: _app.$TokenizedWalletPinModel.instance(this.props.token).retrieve(),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve(),
                tokenizedWalletMsbOfferModel: _app.$TokenizedWalletMsbOfferModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken
                    }
                }),
                tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(this.props.token).retrieve({
                    params: {
                        tokenizedWalletToken: checkoutCart.tokenizedWalletToken,
                        country: auth.country
                    }
                }),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
            };
        },
        ppCashToBalanceExperiment: function ppCashToBalanceExperiment() {
            return (0, _squid.$elmo)('xo:hermesnodeweb:ppcashtoppbalance', {}, 'Trmt_xo_hermesnodeweb_PPCash_to_PPBalance').then(function (ppBalanceFlow) {
                return { enabled: Boolean(ppBalanceFlow && ppBalanceFlow.treatment_name) };
            });
        }
    },

    actions: {
        logout: function logout() {
            var _this = this;

            this.auth.logout().then(function () {
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'PP_AndroidPay_Info',
                    'to': 'process_PP_AndroidPay_Info',
                    'context_id': _this.props.token,
                    'context_type': 'EC-Token'
                });
                _this.auth.redirectToLogin('NOT_YOU');
            });
        },
        redirectToCancelUrl: function redirectToCancelUrl() {
            var cancelUrl = this.models.checkoutAppData.urls.cancel_url;
            _index.$ReturnToMerchant.goTo(cancelUrl);
        },
        'continue': function _continue() {
            _logger.$logger.info('tokenized_wallet', {
                'from': 'PP_AndroidPay_Info',
                'to': 'process_PP_AndroidPay_Info',
                'context_id': this.props.token,
                'context_type': 'EC-Token'
            });

            var fi = this.models.checkoutSession.get('errorData.resolution.data.fi');

            if (fi) {
                var contingency = new _squid.$Contingency(fi.fundingId ? 'EXPIRED_DEBIT_CARD' : 'NEED_DEBIT_CARD');

                _squid.$util.extend(contingency, this.models.checkoutSession.errorData);
                throw contingency;
            }

            if (this.directFundingEnabled) {
                // if direct funding is enabled and the returned future payments does not have FI other than balance,
                // we should not allow user onboard
                var futurePaymentInstruments = this.models.checkoutSession.get('futurePaymentInstruments', []);
                var validFI = futurePaymentInstruments.filter(function (fufI) {
                    return fufI.type !== 'BALANCE';
                });

                _logger.$logger.info('direct_funding_instruments', {
                    'futurePaymentInstruments': futurePaymentInstruments.length,
                    'validFI': validFI.length
                });

                if (validFI && validFI.length === 0) {

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'PP_AndroidPay_Info',
                        'to': 'process_PP_AndroidPay_Info',
                        'context_id': this.props.token,
                        'context_type': 'EC-Token',
                        'int_error_code': 'NoBankAlert'
                    });

                    // Show the No Bank Alert page
                    this.noBank = true;
                    return;
                }
            }
            if (this.models.walletPinModel.isSetupEligible()) {
                _logger.$logger.debug('pinSetup_required');
                _uiRouter.$state.go('checkout.pinSetup');
            } else {
                _uiRouter.$state.go('checkout.review');
            }
        }
    },

    lifecycle: {
        enter: function enter() {
            this.auth = _auth.$AuthModel.instance();
            this.noBank = false;
            this.showNotYou = this.auth && this.auth.showNotYou();
            this.userName = (0, _squid.formatNameInformal)({
                first_name: this.auth.first_name,
                last_name: this.auth.last_name
            }) || this.auth.email;
        },
        populate: function populate() {
            (0, _jquery2['default'])('#tokenizationInfo .infoPage').css('min-height', function () {
                var height = window.innerHeight || document.documentElement && document.documentElement.clientHeight;

                return height && height - 125; // 125px => height of header & action button bottom padding
            });

            this.brandName = this.models.tokenizedWalletInfoModel.brandName();
            this.topupEnabled = this.models.tokenizedFundingCapabilitiesModel.isTopupEnabled();
            this.directFundingEnabled = this.models.tokenizedFundingCapabilitiesModel.isDirectFundingEnabled();
            var ppCashToBalanceExperimentEnabled = this.ppCashToBalanceExperiment.enabled;
            var topupInfo1Key = ppCashToBalanceExperimentEnabled ? 'topup.commonTopupInfo1PPBalance' : 'topup.commonTopupInfo1';
            var topupInfo2Key = ppCashToBalanceExperimentEnabled ? 'topup.commonTopupInfo2PPBalance' : 'topup.commonTopupInfo2';

            if (this.topupEnabled) {
                this.showMsbOffer = this.models.tokenizedWalletMsbOfferModel && this.models.tokenizedWalletMsbOfferModel.enabled;
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('topup.commonTopupInfoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)(topupInfo1Key, { type: this.brandName }),
                    info2: (0, _squid.$renderContent)(topupInfo2Key, { type: this.brandName }),
                    infoMayNeedPin: (0, _squid.$renderContent)('topup.topupInfoMayNeedPin')
                };
            } else {
                this.tokenizationContent = {
                    heading: (0, _squid.$renderContent)('tokenization.infoHeading', { type: this.brandName }),
                    info1: (0, _squid.$renderContent)('tokenization.info1', { type: this.brandName }),
                    info2: (0, _squid.$renderContent)('tokenization.info2'),
                    infoMayNeedPin: (0, _squid.$renderContent)('tokenization.infoMayNeedPin')
                };

                this.noBankErrorMessage = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)('tokenization.noBankHeaderSuggestion', { type: this.brandName })]
                };
            }
        }
    }
});


_auth.$AuthModel;

_squid.$Component;

_squid.$Contingency;

_squid.$elmo;

_squid.formatNameInformal;

_squid.$util;

_squid.$renderContent;

_uiRouter.$state;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletMsbOfferModel;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutAppDataModel;

_index.$ReturnToMerchant;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-tokenization-info/directive.js
// module id = ./pages/xo-tokenization-info/directive.js
// module chunks = 0